import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
} from "@angular/forms";
import { Router, RouterModule } from "@angular/router";
import { AuthService } from "../../services/auth/auth.service";

function matchPasswords(control: AbstractControl): ValidationErrors | null {
  const password = control.get("password")?.value;
  const confirm = control.get("confirmPassword")?.value;
  return password && confirm && password !== confirm ? { mismatch: true } : null;
}

@Component({
  selector: "app-reset-password",
  standalone: true,
  imports: [ReactiveFormsModule, RouterModule],
  templateUrl: "./reset-password.component.html",
  styleUrl: "./reset-password.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetPasswordPageComponent {
  private fb = inject(FormBuilder);
  private auth = inject(AuthService);
  private router = inject(Router);

  busy = signal(false);
  error = signal<string | null>(null);
  success = signal(false);

  form: FormGroup = this.fb.group(
    {
      password: [null, [Validators.required, Validators.minLength(8)]],
      confirmPassword: [null, [Validators.required]],
    },
    { validators: matchPasswords },
  );

  submit() {
    if (!this.form.valid) return;
    this.error.set(null);
    this.busy.set(true);
    const { password } = this.form.value;
    this.auth.updatePassword(password).subscribe({
      next: () => {
        this.success.set(true);
        setTimeout(() => this.router.navigateByUrl("/"), 1500);
      },
      error: (err) => this.error.set(err?.message ?? "Failed to update password"),
    }).add(() => this.busy.set(false));
  }
}
